import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations } from "./i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("afm_lang") || "en");

  useEffect(() => {
    localStorage.setItem("afm_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "en" ? "es" : "en")), []);

  const value = { lang, setLang, toggle, t: translations[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
